import fetchBankAccountInfoSagas from './fetchBankAccountInfo'
import deleteBankAccountInfoSagas from './deleteBankAccountInfo'

// CODE_COMMENTS_11
export default [
  ...fetchBankAccountInfoSagas,
  ...deleteBankAccountInfoSagas,
]
